<template>
  <div>
    <div>
      <router-link to="/">Home</router-link>
      <label class="labelBar"> / </label>
      <router-link to="/servicoPlano">
        Cadastro/Servico Plano Manutenção
      </router-link>
      <label class="labelBar"> / </label>
      <label v-if="!readOnly"> Editar</label>
      <label v-else> Ver</label>
    </div>
    <tab-navegacao />
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center-left">
          <v-col cols="12" sm="6">
            <v-checkbox v-model="itemTroca" label="Item Troca"></v-checkbox>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col>
            <v-textarea
              label="Descrição *"
              v-model="descricao"
              v-uppercase
              counter
              auto-grow
              rows="1"
              :rules="[(v) => !!v || 'A Descrição é obrigatória']"
              :readonly="readOnly"
              required
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col cols="12" sm="6">
          <v-checkbox
            v-model="servicoPlano.ativo"
            @click.native.stop.prevent="checkAssociacao()"
            label="Ativo"
            :readonly="readOnly"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6" class="text-right">
          <v-btn to="/servicoPlano" color="error" class="mr-4" v-if="!readOnly">
            Voltar
          </v-btn>
          <v-btn to="/servicoPlano" color="success" class="mr-4" v-else>
            Voltar
          </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4" v-if="!readOnly">
            Salvar
          </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import { editarServicoPlanoAsync } from "../../../services/servicoPlanoService";
import { mapState, mapActions } from "vuex";
import TabNavegacao from "../../Tabs/TabCadastroPlanoManutencao";
import { getUserPermission } from "@/services/loginService";

export default {
  name: "editarServicoPlano",
  data: () => ({
    overlay: false,
    valid: true,
    descricao: null,
    itemTroca: false,
    readOnly: false,
  }),
  computed: {
    ...mapState("servicoPlano", ["servicoPlano"]),
  },
  methods: {
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await editarServicoPlanoAsync(
          this.servicoPlano.id,
          this.descricao,
          this.itemTroca,
          this.servicoPlano.ativo
        );
        if (resposta) {
          this.overlay = false;
          this.$alert(resposta.message, "Descupe, falha na operação!", "error");
        } else {
          this.overlay = false;
          this.$router.push("/servicoPlano");
        }
      }
    },
    checkAssociacao(){
      
    }
  },
  created: function () {
    this.readOnly = !getUserPermission(1);
    this.descricao = this.servicoPlano.descricao;
    this.itemTroca = this.servicoPlano.itemTroca;
    this.ativo = this.servicoPlano.ativo
  },
  components: {
    TabNavegacao,
  },
};
</script>